import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../library/ProjectStatus';
import TooltipCaller from '../TooltipManager/TooltipCaller';
import favo0 from './../../assets/images/svg/favo-0.svg';
import favo1 from './../../assets/images/svg/favo-1.svg';
import favo2 from './../../assets/images/svg/favo-2.svg';
import favo3 from './../../assets/images/svg/favo-3.svg';
import favo from './../../assets/images/svg/favo.svg';
import { getStepIconByIndex, getStepSlug } from './../../library/ProjectSteps';
import { projectEdit } from './../../library/Routes';
import styles from './ProjectStep.scss';

const rootClassName = styles.rootClassName;

class ProjectStep extends Component {
  constructor(props) {
    super(props);

    this.toClick = this.toClick.bind(this);
    this.toPath = this.toPath.bind(this);
  }

  toPath(path) {
    if (typeof path === 'string') {
      this.props.history.push(path);
    }
  }

  toClick() {
    const id = this.props.match.params.id;
    const stepSlugName = getStepSlug(this.props.stepIndex);
    if (id) {
      this.toPath(projectEdit.getURLWithParams(id, stepSlugName));
    }
  }

  getHint() {
    switch (this.props.stepIndex) {
      case 0:
        return this.props.languageValues.preCadastro;
      case 1:
        return this.props.languageValues['etapa' + this.props.stepIndex];
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
        return this.props.languageValues['etapa' + (this.props.stepIndex - 1)];
      case 2:
        return this.props.languageValues.etapa2_1;
      case 3:
        return this.props.languageValues.etapa2_2;
      default:
        return '';
    }
  }

  getStatus() {
    if (
      this.props.projeto.avaliacoes &&
      this.props.projeto.avaliacoes.length &&
      this.props.projeto.avaliacoes[this.props.stepIndex]
    ) {
      return this.props.projeto.avaliacoes[this.props.stepIndex].status;
    }
    if (this.props.stepIndex === 0) {
      return PROJECT_STATUS_RASCUNHO;
    }
    return -1;
  }

  getFavo() {
    switch (this.getStatus()) {
      case PROJECT_STATUS_RASCUNHO:
        return favo0;
      case PROJECT_STATUS_PENDENTE:
        return favo1;
      case PROJECT_STATUS_APROVADO:
        return favo2;
      case PROJECT_STATUS_REJEITADO:
        return favo3;
      default:
        return favo;
    }
  }

  render() {
    const actived = this.props.stepIndex === this.props.activedStepIndex;
    const allProps = {
      disabled: this.props.enabled ? false : true,
      onClick: () => this.toClick(),
      className:
        (actived
          ? rootClassName + ' ' + rootClassName + '-actived'
          : rootClassName) +
        (!this.props.enabled ? ' ' + rootClassName + '-disabled' : ''),
    };
    return (
      <TooltipCaller
        text={this.getHint()}
        className={
          rootClassName +
          '-tooltip-caller' +
          (actived ? ' ' + rootClassName + '-tooltip-caller-actived' : '')
        }
      >
        <button {...allProps}>
          <div className={rootClassName + '-vertical-line'}></div>
          <div className={rootClassName + '-point'}>
            <img
              className={rootClassName + '-point-favo'}
              src={this.getFavo()}
              alt='icone-favo'
              loading='lazy'
            />
          </div>
          <div className={rootClassName + '-current '}>
            <img
              className={rootClassName + '-current-favo'}
              src={this.getFavo()}
              alt='icone-favo'
              loading='lazy'
            />
            <img
              src={getStepIconByIndex(this.props.stepIndex)}
              className={rootClassName + '-icon'}
              alt='icone-favo'
              loading='lazy'
            />
          </div>
        </button>
      </TooltipCaller>
    );
  }
}

ProjectStep.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  activedStepIndex: PropTypes.number.isRequired,
  enabled: PropTypes.bool,
  status: PropTypes.number,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

export default connect(mapStateToProps)(withRouter(ProjectStep));
